/*
 *  I03PSYCHROAIRCalcul.js
 *
 *  Created by Sébastien Hecart on 2018-08-02 18:39:45 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

//TODO CASE import {} from "@batical/data/src/Queries/BatiQueries";
import { I03PSYCHROAIR_State } from '@batical/types/src'
//TODO IF REQUIREDimport {} from '@batical/types/src';
function I03PSYCHROAIR_docalcul(state: I03PSYCHROAIR_State) {
  //TODO CALCUL
  //=1/(287.06*(273.15+state.in_tempAir))*(state.in_pressionAtmospherique*100-230.617*state.in_humiditeRelative/100*exp(17.5043*state.in_tempAir/(241.2+state.in_tempAir)))
  state.res_masseVolumeAir =
    (1 / (287.06 * (273.15 + state.in_tempAir))) *
    (state.in_pressionAtmospherique * 100 -
      ((230.617 * state.in_humiditeRelative) / 100) * Math.exp((17.5043 * state.in_tempAir) / (241.2 + state.in_tempAir)))
  state.res_viscDyn = ((1.48 / 1000000) * Math.sqrt(state.in_tempAir + 273.15)) / (1 + 119.4 / (state.in_tempAir + 273.15))
  state.res_viscCin = state.res_viscDyn / state.res_masseVolumeAir
  state.res_pressionVapeur =
    state.in_tempAir <= 0
      ? Math.pow(10, 2.7862 + (9.7561 * state.in_tempAir) / (272.67 + state.in_tempAir))
      : Math.pow(10, 2.7862 + (7.5526 * state.in_tempAir) / (239.21 + state.in_tempAir))
  state.res_pressionPartielle = (state.res_pressionVapeur * state.in_humiditeRelative) / 100
  state.res_humSpec =
    (((0.6221 * state.in_humiditeRelative) / 100) * state.res_pressionVapeur) /
    (state.in_pressionAtmospherique * 100 - (state.in_humiditeRelative / 100) * state.res_pressionVapeur)
  state.res_condThermique =
    1.5207 * Math.pow(10, -11) * Math.pow(273.15 + state.in_tempAir, 3) -
    4.857 * Math.pow(10, -8) * Math.pow(273.15 + state.in_tempAir, 2) +
    1.0184 * Math.pow(10, -4) * (273.15 + state.in_tempAir) -
    3.9333 * Math.pow(10, -4)
  state.res_tempRose =
    (237.48 * (Math.log((state.in_humiditeRelative / 100) * state.res_pressionVapeur) - 6.41)) /
    (23.69 - Math.log((state.in_humiditeRelative / 100) * state.res_pressionVapeur))
  state.res_volMassique = 1 / state.res_masseVolumeAir
  state.res_enthAir = 1 * state.in_tempAir + state.res_humSpec * (2490 + 1.96 * state.in_tempAir)
  state.res_tempSaturation = -0.0023 * Math.pow(state.res_enthAir, 2) + 0.5955 * state.res_enthAir - 5.9859
  state.invalidated = false
  return state
}

export default I03PSYCHROAIR_docalcul
